import React from "react";

const ITEMS = [
  "Shopify",
  "React",
  "Node.js",
  "Laravel",
  "Liquid",
  "Next.js",
  "Performance",
  "SEO",
  "Elasticsearch",
  "MongoDB",
];

function Row() {
  return (
    <span className="row">
      {ITEMS.map((it, i) => (
        <React.Fragment key={i}>
          <span className={i % 2 === 0 ? "" : "stroke"}>{it}</span>
          <span className="dot" />
        </React.Fragment>
      ))}
    </span>
  );
}

export default function Marquee({ reverse = false }) {
  return (
    <div className={`marquee ${reverse ? "marquee--reverse" : ""}`}>
      <div className="marquee__track" aria-hidden="true">
        <Row />
        <Row />
      </div>
    </div>
  );
}
